import React, { useEffect, useState } from 'react';
import { useFirebase } from '../contexts/FirebaseContext';
import { getStaffByEmail, Staff } from '../services/staffService';
import { EmployeeApprovals } from './EmployeeApprovals';

export const ApprovalsPage: React.FC = () => {
  const { user, tenantId } = useFirebase();
  const [staff, setStaff] = useState<Staff | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.email || !tenantId) {
      setLoading(false);
      return;
    }

    const fetchStaff = async () => {
      setLoading(true);
      try {
        const staffData = await getStaffByEmail(tenantId, user.email);
        setStaff(staffData);
      } catch (e) {
        console.error('Error fetching staff data for approvals:', e);
      } finally {
        setLoading(false);
      }
    };
    fetchStaff();
  }, [user?.email, tenantId]);

  if (loading) return <div className="flex items-center justify-center p-20"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div></div>;

  return <EmployeeApprovals staff={staff} />;
};
